import { useAuth } from '../../../__legacy__/hooks/useAuth'

export const useVerifyMediaAPI = () => {
  const { authenticatedPost, authenticatedDelete } = useAuth()
  /**
   * Marks an arp media element as a verified remix for a sample pack
   * @param samplePackId The sp ID to verify the remix for
   * @param mediaToVerifyArpId The arp ID of the remix to verify
   */
  const verifyMediaForSamplePack = async (
    samplePackId: number,
    mediaToVerifyArpId: number
  ): Promise<void> => {
    const { data } = await authenticatedPost(
      `/api/v2/sample-pack/${samplePackId}/verified-arp-medias`,
      { arpMediaId: mediaToVerifyArpId }
    )

    return data
  }

  /**
   * Marks an already-verified arp media element remix as unverified
   * @param samplePackId The sp ID to unverify the remix for
   * @param mediaToUnverifyArpId The arp ID of the remix to unverify
   */
  const unverifyMediaForSamplePack = async (
    samplePackId: number,
    mediaToUnverifyArpId: number
  ): Promise<void> => {
    const { data } = await authenticatedDelete(
      `/api/v2/sample-pack/${samplePackId}/verified-arp-medias/${mediaToUnverifyArpId}`
    )

    return data
  }

  /**
   * Marks an arp media element as a verified remix of another arp media element
   * @param arpMediaFor The arp ID that was remixed
   * @param mediaToVerifyArpId The arp ID of the remix to verify
   */
  const verifyMediaForArpID = async (
    arpMediaFor: number,
    mediaToVerifyArpId: number
  ): Promise<void> => {
    const { data } = await authenticatedPost(
      `/api/v2/arp-media/${arpMediaFor}/verified-arp-medias`,
      { arpMediaId: mediaToVerifyArpId }
    )

    return data
  }

  /**
   * Marks an already-verified arp media element remix as unverified
   * @param arpMediaFor The arp ID that was remixed
   * @param mediaToUnverifyArpId The arp ID of the remix to unverify
   */
  const unverifyMediaForArpID = async (
    arpMediaFor: number,
    mediaToUnverifyArpId: number
  ): Promise<void> => {
    const { data } = await authenticatedDelete(
      `/api/v2/arp-media/${arpMediaFor}/verified-arp-medias/${mediaToUnverifyArpId}`
    )

    return data
  }

  return {
    verifyMediaForSamplePack,
    unverifyMediaForSamplePack,
    verifyMediaForArpID,
    unverifyMediaForArpID
  }
}
